/**
 * /flashfeo — LP fixa da ação Flash FEO (catálogo dos produtos que não são pós:
 * 6 certificações, Star Cursos e Agente IA). Contador com reset diário.
 */
import { createFileRoute } from "@tanstack/react-router";
import { FlashfeoPage } from "@/components/lps/FlashfeoPage";
import { getAcoesStateFn } from "@/lib/campanhas/acoes.functions";

export const Route = createFileRoute("/flashfeo")({
  head: () => ({
    meta: [
      { title: "Flash FEO" },
      {
        name: "description",
        content:
          "Flash FEO: certificações da Fisio em Ortopedia por R$197, Star Cursos por R$107 e Agente IA por R$97. Ofertas relâmpago válidas por 24 horas.",
      },
      { property: "og:title", content: "Flash FEO" },
      {
        property: "og:description",
        content: "Certificações, Star Cursos e Agente IA com ofertas relâmpago por 24 horas.",
      },
      { property: "og:url", content: "https://fisioemortopedia.com.br/flashfeo" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Flash FEO" },
      { name: "twitter:description", content: "Ofertas relâmpago em certificações, Star Cursos e Agente IA." },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/flashfeo" }],
  }),
  loader: () => getAcoesStateFn(),
  component: FlashfeoRoute,
});

function FlashfeoRoute() {
  const acoes = Route.useLoaderData();
  return <FlashfeoPage ativa={Boolean(acoes?.flashfeo?.ativa)} />;
}
